import gCard from "@/components/g-card/g-card.vue"
import router from "@/router"
import { JWTService } from "@/shared/services/jwt.js"
import axios from "axios"

export default {
  name:'Tapume',
  components:{
    'g-card': gCard
  },
  data () {
    return {
        codigoExternoUsuario: '',
        appSecret: ''
    }
  },
  
  mounted () {
    

 },
  methods:{
    SSO(){
        this.axios.post(process.env.VUE_APP_WEB_API + 'LoginSSO',{
            CodigoExternoUsuario: this.codigoExternoUsuario,
            AppSecret: this.appSecret,     
          },{})
        .then(res => {
          if (res.data.autenticado) {
            JWTService.SaveToken(res.data.token)
            axios.defaults.headers.common['Authorization'] = `Bearer ${JWTService.GetToken()}`;
            router.push('/dashboard')
          }
          else{
            router.push('/')
          }
        })
    }
   
  }
}